import { render, staticRenderFns } from "./MoreServiceDetailDialog.vue?vue&type=template&id=05398858&scoped=true&"
import script from "./MoreServiceDetailDialog.vue?vue&type=script&lang=js&"
export * from "./MoreServiceDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./MoreServiceDetailDialog.vue?vue&type=style&index=0&id=05398858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05398858",
  null
  
)

export default component.exports